import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=164db412&scoped=true"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=164db412&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164db412",
  null
  
)

export default component.exports